import { objectDeepMerge } from 'helpers'

import light from '../light'

const dark = {}

const theme = objectDeepMerge(light, dark)
export default theme
